import {
  SnippetElement,
  defineElement,
  onClick,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/snippets/util-modal/util-modal.ts
var UtilModal = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.isOpen = false;
  }
  connectedCallback() {
    this.dialog.addEventListener("close", () => {
      this.close();
    });
  }
  toggle() {
    if (!this.isOpen) {
      this.open();
    } else {
      this.close();
    }
  }
  open() {
    if (this.isOpen) {
      return;
    }
    this.emit("opened");
    this.isOpen = true;
    this.classList.remove("hidden");
    this.dialog.showModal();
  }
  close() {
    if (!this.isOpen) {
      return;
    }
    this.emit("closed");
    this.isOpen = false;
    this.classList.add("hidden");
    this.dialog.close();
  }
};
__decorateClass([
  query("dialog")
], UtilModal.prototype, "dialog", 2);
__decorateClass([
  onClick("[close-btn]")
], UtilModal.prototype, "toggle", 1);
__decorateClass([
  onClick("[data-bg-close]")
], UtilModal.prototype, "close", 1);
UtilModal = __decorateClass([
  defineElement("util-modal")
], UtilModal);
export {
  UtilModal
};
